import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import store from './store/index'

// Attach the Firebase ID token to all nf-api requests (ready for API auth).
import { installApiAuthInterceptor } from './composables/apiAuthInterceptor'
installApiAuthInterceptor()

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import VueGoogleMaps from '@fawmi/vue-google-maps'

// Import Tailwind CSS
import './assets/styles/tailwind.css'

createApp(App)
    .use(store)
    .use(router)
    .component('EasyDataTable', Vue3EasyDataTable)
    .use(VueGoogleMaps, { load: { key: 'AIzaSyBP2ef3NaOOAit6z276ruULnd897zlubUc', libraries: "places" } })
    .mount('#app')
